import { useVenuesByCityMasterdataQuery } from "@/features/masterdata/queries/venues-by-city-masterdata-query";

export function useVenuesByCityMasterdata(cityCodesRef: Ref<string[]>) {
  const venuesQuery = useVenuesByCityMasterdataQuery(cityCodesRef);

  const venues = computed(() => venuesQuery.data.value || []);

  return {
    venues,
    isLoading: venuesQuery.isLoading,
    error: venuesQuery.error,
    refetch: venuesQuery.refetch,
  };
}
